import React, { useState } from 'react';
import { Dialog } from './Dialog';
import { PaymentForm } from '../Payment/PaymentForm';
import { PaystackScript } from '../Payment/PaystackScript';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
interface PaymentDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
export const PaymentDialog = ({
  isOpen,
  onClose
}: PaymentDialogProps) => {
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'success'>('pending');
  const [reference, setReference] = useState('');
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setPaymentStatus('success');
  };
  const handleClose = () => {
    // Reset state when dialog closes
    if (paymentStatus === 'success') {
      setTimeout(() => {
        setPaymentStatus('pending');
        setReference('');
      }, 300);
    }
    onClose();
  };
  return <>
      <PaystackScript data-id="element-1408" />
      <Dialog isOpen={isOpen} onClose={handleClose} title={paymentStatus === 'success' ? 'Payment Successful' : 'Join The Networking Salon'} size="md" data-id="element-1409">
        <div className="p-4" data-id="element-1410">
          {paymentStatus === 'pending' ? <PaymentForm onSuccess={handleSuccess} data-id="element-1411" /> : <div className="text-center py-6" data-id="element-1412">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-1413">
                <Check size={32} className="text-gray-700" data-id="element-1414" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1415">
                Payment Successful
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1416">
                Thank you for joining The Networking Salon Inner Circle!
              </p>
              <p className="text-sm text-gray-500 mb-6" data-id="element-1417">
                Reference: {reference}
              </p>
              <p className="text-gray-600 mb-6" data-id="element-1418">
                We've sent a confirmation email with details about your
                membership.
              </p>
              <Link to="/join-the-salon" onClick={handleClose} data-id="element-1419">
                <Button className="w-full" data-id="element-1420">Join The Salon</Button>
              </Link>
            </div>}
        </div>
      </Dialog>
    </>;
};